
<template>
  <div class="header">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'WheelHeader'
}
</script>
<style lang="scss" scoped>
</style>


